/**
 * Transforms the completed status from a string to a boolean.
 * - 'Completed' -> true
 * - 'Attempted' -> false
 * - For 'All' or empty values, returns undefined (to omit the parameter).
 *
 * @param {string} status - The completion status as a string.
 * @returns {boolean|undefined} - Returns true for 'Completed', false for 'Attempted', and undefined for 'All' or no value.
 */
export const transformCompletedStatus = (status) => {
  if (status === 'Completed') return true;
  if (status === 'Attempted') return false;
  return undefined; // For 'All' or empty case
};
